import React from 'react';
import { useSearchParams } from 'react-router-dom';
import Gallery from '../components/Gallery';
import ImageModal from '../components/ImageModal';
import galleryData from '../data/galleryData';
import '../styles/home.css';

function Artwork() {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedPhotoId = searchParams.get('photo');

  // Find the selected photo
  const selectedPhoto = selectedPhotoId
    ? galleryData.find(photo => photo.id === selectedPhotoId)
    : null;

  // Find current index for navigation
  const currentIndex = selectedPhoto
    ? galleryData.findIndex(photo => photo.id === selectedPhotoId)
    : -1;

  const handleCardClick = (photo) => {
    setSearchParams({ photo: photo.id });
  };

  const handleCloseModal = () => {
    setSearchParams({});
  };

  const handleNextPhoto = () => {
    if (currentIndex === -1) return;
    const nextIndex = (currentIndex + 1) % galleryData.length;
    setSearchParams({ photo: galleryData[nextIndex].id });
  };

  const handlePrevPhoto = () => {
    if (currentIndex === -1) return;
    const prevIndex = (currentIndex - 1 + galleryData.length) % galleryData.length;
    setSearchParams({ photo: galleryData[prevIndex].id });
  };

  return (
    <main className="home-page">
      <Gallery
        galleryData={galleryData}
        onCardClick={handleCardClick}
        folder="artwork"
      />

      {selectedPhoto && (
        <ImageModal
          photo={selectedPhoto}
          onClose={handleCloseModal}
          onNext={handleNextPhoto}
          onPrev={handlePrevPhoto}
          folder="artwork"
        />
      )}
    </main>
  );
}

export default Artwork;
